<template>
  <div class="h4">{{ label }}</div>

  <template v-for="(group, index) in groups" :key="index">
    <div v-if="isRadioGroupField(group.name)" class="mt-10">
      <div class="paragraph-m_h font-600 mb-4">{{ group.name }}</div>
      <e-radio-group
        :model-value="group.items.some(item => item.selectedOptions.length > 0) ? 'yes' : 'no'"
        :items="radioOptions"
        :disabled="isQuestionnaireSent"
        inline
        @update:model-value="(value: 'yes' | 'no') => onRadioChange(value, group)"
      />
    </div>

    <checkbox-dropdown
      v-else
      v-model="group.isChecked"
      :label="group.name"
      :disabled="isQuestionnaireSent"
      class="mt-10"
    >
      <template v-if="!isQuestionnaireSent">
        <template v-for="(item, itemIndex) in group.items" :key="itemIndex">
          <div v-if="group.items.length > 1" class="paragraph-m_h font-600 mb-4 mt-4">{{ item.name }}</div>
          <combobox-with-list v-model="item.selectedOptions" label="Добавить" item-title="name" :options="item.options" />
        </template>
      </template>

      <template v-else>
        <div v-for="(item, itemIndex) in group.items" :key="itemIndex">
          <template v-if="item.selectedOptions.length">
            <div v-if="group.items.length > 1" class="paragraph-m_h font-600 mb-4 mt-4">{{ item.name }}</div>
            <div class="d-flex flex-wrap row-gap-2 col-gap-2">
              <e-chip v-for="(option, optionIndex) in item.selectedOptions" :key="optionIndex">
                {{ option }}
              </e-chip>
            </div>
          </template>
        </div>
      </template>
    </checkbox-dropdown>
  </template>
</template>

<script setup lang="ts">
import type { TreatmentGroup } from '@/parts/content/types';
import CheckboxDropdown from '@/core/components/interface/CheckboxDropdown.vue';
import ComboboxWithList from '@/core/components/interface/ComboboxWithList.vue';
import { EChip, ERadioGroup } from '@/core/components/ui';
import { useContentStore } from '@/parts/content/store';

const { isQuestionnaireSent } = useContentStore();

defineProps<{
  groups: TreatmentGroup[];
  label: string;
}>();

const radioOptions = [
  { title: 'Есть', value: 'yes' },
  { title: 'Нет', value: 'no' },
];

const isRadioGroupField = (groupName: string) => {
  return groupName === 'Питание по лечебной программе' || 
         groupName === 'Питьевое лечение минеральной водой';
};

const onRadioChange = (value: 'yes' | 'no', group: TreatmentGroup) => {
  if (value === 'yes') {
    group.isChecked = true;
    group.items.forEach(item => {
      item.selectedOptions = ['Есть'];
    });
  } else {
    group.isChecked = false;
    group.items.forEach(item => {
      item.selectedOptions = [];
    });
  }
};
</script>

<style scoped lang="scss"></style>
